import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropertyDetails from '../elements/property-details';
import { OptionImage } from './OptionImage';
import { productContentPropTypes } from 'core/propTypes/propTypes';
import { all_routes } from 'core/data/routes/all_routes';

export const ProductContent = memo(({
  item,
  selectedOption,
  onOptionClick,
  optionsRef,
  id
}) => {

  const validOptionsCount = item.product_option?.filter(option => 
    ['color', 'design', 'image'].includes(option.display_type)
  ).length;

  return (
    <div className="product-card__content">
      <div className="product-card__title">
        <h2 style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          <Link to={all_routes.productDetails + "/" + id}>{item?.title}</Link>
        </h2>
      </div>
      {item.details && (
        <PropertyDetails details={item.details} />
      )}
      <div className="options-container">
      {validOptionsCount === 0 ? (
        <>
          <div className="options-header">
            <div className="options-header__title top-rated-product-info ">
              <h6 className="m-0">Descripción</h6>
            </div>
          </div>
        <div className="product-card__description">
          <p>{item.description || item.product.description }</p>
        </div>
        </>
      ) : (
        <>
          <div className="options-header">
            <div className="options-header__title top-rated-product-info ">
              <h6 className="m-0">Alternativas</h6>
            </div>
            <span className="options-count d-none d-md-block">
              {validOptionsCount} opciones
            </span>
          </div>
          <div ref={optionsRef} className="scroll-light gap-1 pe-0" style={{ display: 'flex', overflowX: 'auto', maxHeight: '60px' }}>
            {item.product_option?.map((option, index) => {
              if (option.display_type === 'image') {
                return (
                  <OptionImage
                    key={index}
                    option={option}
                    isSelected={selectedOption === option}
                    onClick={() => onOptionClick(index)}
                  />
                );
              } else if (option.display_type === 'color') {
                return (
                  <div
                    key={index}
                    className={`option-color ${selectedOption === option ? 'ltn__border-primary' : ''}`}
                    style={{ backgroundColor: option.value }}
                    onClick={() => onOptionClick(index)}
                  />
                );
              }
              return null;
            })}
          </div>
        </>
      )}
        <div className="d-flex justify-content-between mt-auto">
          <Link to={all_routes.productDetails +  "/" + id }
            className="btn py-1 px-2 btn-primary w-100 mt-2"
          >
            <span style={{ fontWeight: '500' }}>
              Detalles y opciones
            </span>
          </Link>
        </div>
      </div>
    </div>
  )
});

ProductContent.propTypes = productContentPropTypes;